import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import scrollToComponent from 'react-scroll-to-component';

import {getJsonFromUrl} from '../../../utils/url';
import {formatQuerystring} from '../../../utils/formatting';
import {reSortDiamonds, reSortProducts} from '../../../utils/product';

import * as productActionCreators from '../../../actions/product';
let allActionCreators = Object.assign({}, productActionCreators);

import {GalleryBreadcrumbsContainer} from './blocks/GalleryBreadcrumbs';

import EngagementSplash from './blocks/splash/EngagementSplash';
import {EngagementFiltersContainer} from './blocks/filters/EngagementFilters';
import {MixedResultsContainer} from './blocks/results/MixedResults';
import {DiamondResultsContainer} from './blocks/results/DiamondResults';
import {SettingResultsContainer} from './blocks/results/SettingResults';

import MensBandsSplash from './blocks/splash/MensBandsSplash';
import {MensBandsFiltersContainer} from './blocks/filters/MensBandsFilters';
import {BandResultsContainer} from './blocks/results/BandResults';

import WomensBandsSplash from './blocks/splash/WomensBandsSplash';
import {WomensBandsFiltersContainer} from './blocks/filters/WomensBandsFilters';

import FashionSplash from './blocks/splash/FashionSplash';
import {FashionFiltersContainer} from './blocks/filters/FashionFilters';
import {FashionResultsContainer} from './blocks/results/FashionResults';

import {MensJewelryFiltersContainer} from './blocks/filters/MensJewelryFilters';
import {MensJewelryResultsContainer} from './blocks/results/MensJewelryResults';

import RhinoLoading from '../common/RhinoLoading';


class Gallery extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

    let getData = getJsonFromUrl();
    let hasQuerystring = Object.entries(getData).length > 0 && getData.constructor === Object;

    const allowedModes = ['mixed', 'diamond', 'setting'];
    let modeVal = 'mixed';
    if(hasQuerystring && getData.mode) {
      modeVal = getData.mode;
    }
    if(!allowedModes.includes(modeVal)) {
      modeVal = 'mixed';
    }

    if(getData && getData.view == 'results') {

    }

		this.state = {

      scrollPos: 0,
      filtersOpen: window.innerWidth > 1024 ? true : false,

      lastRequest: null, 
      resultsLoaded: false,
      requestPending: hasQuerystring,
      getData: getData,

      diamondLastRequest: null,
      diamondRequestPending: false,
      diamondResultsLoaded: true,

      engagementMode: modeVal,

      // displaySplash: !hasQuerystring || ((Object.entries(getData).length === 1) && (getData.mode == 'diamond' || getData.mode == 'setting')),
      displaySplash: false,

      mixedResultsTab: getData && getData.tabtype && getData.tabtype == 'setting' ? 'setting' : 'diamond',
    };

    // if(hasQuerystring && !((Object.entries(getData).length === 1) && (getData.mode == 'diamond' || getData.mode == 'setting'))) {
    let pageNum = this.props.product.currentPage ? this.props.product.currentPage : 1;
    this.fetchInitResults(getData, pageNum);
    // }

    // Bind event listeners
    this.monitorWidth = ::this.monitorWidth;
    this.getScrollPos = ::this.getScrollPos;
    // this.locationChange = ::this.locationChange;

    // Request controllers
    this.productController = null;
	}

	componentDidMount() {
    document.title = 'Diamonds Direct';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";

    window.addEventListener('resize', this.monitorWidth, false);
    window.addEventListener('scroll', this.getScrollPos, false);
    // document.addEventListener('change', this.locationChange, false);
  }

  componentDidUpdate(prevProps, prevState) {

    if(this.props.route.productMode != prevProps.route.productMode) {
      this.setState({ displaySplash: true, filtersOpen: true });
      this.props.productSaveResults(null);
    }

    try {
      Load_Buttons_Hands();
    } catch(err) {
      console.error(err);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.monitorWidth, false);
    window.removeEventListener('scroll', this.getScrollPos, false);
    
    if(this.productController) {
      this.productController.abort();
    }
  }

  monitorWidth() {
    // let foundModal = this.getModalBody();
    if(window.innerWidth <= 1024 && this.state.displaySplash === true && this.state.filtersOpen === false) {
      this.setState({ filtersOpen: true }, () => {
        // this.setTimeout(() => {
        //   this.setState({ displaySplash: false });
        // }, 500);
      });
    }
  }

  getScrollPos() {
    this.setState({
      scrollPos: window.pageYOffset,
    });
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  fetchInitResults(receivedData, currentPage = 1) {

    if(this.props.route.productMode != "engagement") {
      this.updateData(formatQuerystring(receivedData));
    } else {

      // Price excluded
      const diamondKeys = [
        "shape",
        "caratMin",
        "caratMax",
        "color",
        "clarityMin",
        "clarityMax",
        "cutMin",
        "cutMax",
        "polMin",
        "polMax",
        "symMin",
        "symMax",
        "fluorMin",
        "fluorMax",
        "depthMin",
        "depthMax",
        "tableMin",
        "tableMax",
      ];

      let settingData = {};
      let diamondData = {};

      for(const [key, value] of Object.entries(receivedData)) {
        if(diamondKeys.includes(key)) {
          diamondData[key] = value;
        } else {
          settingData[key] = value;
        }
      }

      this.updateEngagementSilently(settingData, currentPage);
      this.updateDiamondDataSilently(diamondData, currentPage);
    }
  }

  // Update setting product data
  updateData(queryString) {

    let thisRequest = Date.now();

    if(this.productController) {
      this.productController.abort();
    }
    const productController = new AbortController();
    this.productController = productController;

    this.setState({
      requestPending: true,
      lastRequest: thisRequest,
      displaySplash: false,
    }, () => {
      
      // Limited request
      console.log('Limited request');
      this.props.productFetchProducts(`${queryString}&limit=50`, productController.signal)
      .then((respData) => {

        if(thisRequest == this.state.lastRequest) {

          const filtersSnapshot = Object.assign({}, this.props.product.productFilters);
          const filteredResults = reSortProducts(respData.success.products, filtersSnapshot);
          
          this.props.productSaveResults(filteredResults, respData.success.count);
          this.setState({
            requestPending: false,
            resultsLoaded: true,
          }, () => {

            // Full request
            this.props.productFetchProducts(queryString, productController.signal)
            .then((respData) => {

              if(thisRequest == this.state.lastRequest) {
                const filteredResults2 = reSortProducts(respData.success.products, filtersSnapshot);
                this.props.productSaveResults(filteredResults2, respData.success.count);
              }
            })
            .catch((errResp) => {
              if(productController.signal.aborted) {
                // Request aborted; do nothing
              }
            });
          });
        }
      })
      .catch((errResp) => {
        if(productController.signal.aborted) {
          // Request aborted; do nothing
        }
      });
    });
  }

  updateEngagementSilently(queryData = {}, currentPage = 1) {
    
    this.props.productSaveProductQueryFilters(queryData, 'setting', currentPage);
    setTimeout(() => {

      if(this.productController) {
        this.productController.abort();
      }
      const productController = new AbortController();
      this.productController = productController;

      const queryString = formatQuerystring(this.props.product.productFilters);

      this.props.productFetchProducts(`${queryString}&limit=50`, productController.signal)
      .then((respData) => {

        const filtersSnapshot = Object.assign({}, this.props.product.productFilters);
        const filteredResults = reSortProducts(respData.success.products, filtersSnapshot);

        this.props.productSaveResults(filteredResults, respData.success.count);
        this.setState({
          resultsLoaded: true,
          displaySplash: false,
        }, () => {
          this.props.productFetchProducts(queryString, productController.signal)
          .then((respData) => {
            const filteredResults2 = reSortProducts(respData.success.products, filtersSnapshot);
            this.props.productSaveResults(filteredResults2, respData.success.count);
          })
          .catch((errResp) => {
            if(productController.signal.aborted) {
              // Request aborted; do nothing
            }
          });
        });
      })
      .catch((errResp) => {
        if(productController.signal.aborted) {
          // Request aborted; do nothing
        }
      });
    }, 200);
  }

  updateDiamondData(queryString) {

    let thisRequest = Date.now();

    this.setState({
      diamondRequestPending: true,
      diamondLastRequest: thisRequest,
      displaySplash: false,
    }, () => {

      this.props.productFetchDiamonds(queryString)
      .then((respData) => {
        
        if(thisRequest == this.state.diamondLastRequest) {
          const filteredResults = reSortDiamonds(respData.results, this.props.product.diamondFilters);
          this.props.productSaveDiamondResults(filteredResults, respData.count < 100 ? filteredResults.length : respData.count);
          this.setState({
            diamondRequestPending: false,
            diamondResultsLoaded: true,
          });

          // Fire engagement search if one not present
          // if(this.props.product.productResults === null) {
          //   this.updateEngagementSilently();
          // }
        } else {


        }
      });
    });
  }

  addDiamondData() {

    const queryString = formatQuerystring(Object.assign({}, this.props.product.diamondFilters, { page: this.props.product.diamondFilters + 1}));
    this.props.productFetchDiamonds(queryString)
    .then((respData) => {
      const filteredResults = reSortDiamonds(respData.results, this.props.product.diamondFilters);
      this.props.productAppendDiamondResults(filteredResults);
    });
  }

  updateDiamondDataSilently(queryData = {}, currentPage = 1) {

    this.props.productSaveDiamondQueryFilters(queryData, currentPage);
    setTimeout(() => {
      this.props.productFetchDiamonds(formatQuerystring(this.props.product.diamondFilters))
      .then((respData) => {
        const filteredResults = reSortDiamonds(respData.results, this.props.product.diamondFilters);
        this.props.productSaveDiamondResults(filteredResults, filteredResults.length < 100 ? filteredResults.length : respData.count);
        this.setState({
          diamondResultsLoaded: true,
          displaySplash: false,
        });
      });
    }, 200);
  }

  unconditionalSubmit() {

    this.updateData(formatQuerystring(this.props.product.productFilters));
    this.updateDiamondData(formatQuerystring(this.props.product.diamondFilters));

    setTimeout(() => {
      this.setState({ filtersOpen: false });
    }, 100);
  }

  dataRefresh() {
    let thisRequest = Date.now();
    this.setState({
      requestPending: true,
      lastRequest: thisRequest,
    }, () => {
      setTimeout(() => {
        if(thisRequest == this.state.lastRequest) {
          this.setState({
            requestPending: false,
            resultsLoaded: true,
          });
        }

      }, 250);
    });
  }

  openFilters() {
    this.setState({ filtersOpen: true });
  }

  openAndScroll() {
    scrollToComponent(this.galleryTop, {
      offset: 0, 
      align: 'top', 
      duration: 300, 
      ease: 'inOutCube',
    });
    this.setState({ filtersOpen: true });
  }

  closeFilters(shouldSearch = true) {

    if(window.innerWidth <= 1024 && shouldSearch) {
      this.unconditionalSubmit();
    }
    this.setState({ filtersOpen: false });
  }

  setEngagementMode(modeVal) {
    this.setState({ engagementMode: modeVal }, () => {
      console.log(this.state.engagementMode);
    });
  }

  updateMixedResultsTab(tabVal) {
    this.setState({ mixedResultsTab: tabVal });
  }

  renderFilters() {
    switch(this.props.route.productMode) {
      case "engagement":
        return <EngagementFiltersContainer 
                setMode={::this.setEngagementMode} 
                setMixedResultsTab={::this.updateMixedResultsTab}
                updateMethod={::this.updateData} 
                updateDiamondsMethod={::this.updateDiamondData}
                closeMethod={::this.closeFilters} />;
      case "mensbands":
        return <MensBandsFiltersContainer 
                updateMethod={::this.updateData} 
                closeMethod={::this.closeFilters} />;
      case "womensbands":
        return <WomensBandsFiltersContainer 
                updateMethod={::this.updateData} 
                closeMethod={::this.closeFilters} />;
      case "fashion":
        return <FashionFiltersContainer 
                updateMethod={::this.updateData} 
                closeMethod={::this.closeFilters} />;
      case "mens":
        return <MensJewelryFiltersContainer 
                updateMethod={::this.updateData} 
                closeMethod={::this.closeFilters} />;
      default:
        return null;
    }
  }

  renderSplashPage() {
    switch(this.props.route.productMode) {
      case "engagement":
        return <EngagementSplash />;
      case "mensbands":
        return <MensBandsSplash />;
      case "womensbands":
        return <WomensBandsSplash />;
      case "fashion":
        return <FashionSplash />;
      default:
        return null;
    }
  }

  renderResultsSection() {
    switch(this.props.route.productMode) {
      case "engagement":
        return this.getEngagementResultsTemplate();
      case "mensbands":
        return <BandResultsContainer 
                updateMethod={::this.dataRefresh} 
                showSplashPage={::this.showSplashPage} 
                gender='mensband'
                openFilters={::this.openAndScroll} />;
      case "womensbands":
        return <BandResultsContainer 
                updateMethod={::this.dataRefresh} 
                showSplashPage={::this.showSplashPage} 
                gender='womensband'
                openFilters={::this.openAndScroll} />;
      case "fashion":
        return <FashionResultsContainer 
                updateMethod={::this.dataRefresh} 
                showSplashPage={::this.showSplashPage}
                openFilters={::this.openAndScroll} />;
      case "mens":
        return <FashionResultsContainer 
                updateMethod={::this.dataRefresh} 
                showSplashPage={::this.showSplashPage} 
                showAd={false}
                openFilters={::this.openAndScroll} />;
      default:
        return null;
    }
  }

  getEngagementResultsTemplate() {
    switch(this.state.engagementMode) {
      case "mixed":
        return <MixedResultsContainer 
                updateMethod={::this.dataRefresh} 
                openFilters={::this.openFilters} 
                tabValue={this.state.mixedResultsTab}
                showSplashPage={::this.showSplashPage}
                openFilters={::this.openAndScroll} />;
      case "diamond":
        return <DiamondResultsContainer 
                updateMethod={::this.dataRefresh}
                setParentMode={::this.setEngagementMode}
                showSplashPage={::this.showSplashPage}
                openFilters={::this.openAndScroll} />;
      case "setting":
        return <SettingResultsContainer 
                updateMethod={::this.dataRefresh}
                setParentMode={::this.setEngagementMode}
                showSplashPage={::this.showSplashPage}
                openFilters={::this.openAndScroll} />;
      default:
        return null;
    }
  }

  showSplashPage() {

    // console.log(this.galleryTop);

    scrollToComponent(this.galleryTop, {
      offset: 0, 
      align: 'top', 
      duration: 300, 
      ease: 'inOutCube',
    });

    this.setState({ displaySplash: true });
  }

  hideSplashPage() {
    scrollToComponent(this.galleryTop, {
      offset: 0, 
      align: 'top', 
      duration: 300, 
      ease: 'inOutCube',
    });
    this.setState({ displaySplash: false });
  }

	render() {

    // if(window.location.host.indexOf('staging') >= 0) { 
      try {
        Load_Buttons_Hands();
      } catch(err) {
        console.error(err);
      }
    // }

		return <div className='Gallery' ref={(div) => { this.galleryTop = div; }}>
			<div className='rbBreadcrumbsWrapper'>
        <GalleryBreadcrumbsContainer 
          showingResults={this.state.requestPending == false}
          showingSplashPage={this.state.displaySplash}
          disableSplash={::this.hideSplashPage} />
      </div>
      <div className={this.state.filtersOpen ? 'rbFiltersWrapper filtersOpen' : 'rbFiltersWrapper'}> 
        <div className='filtersIndicator' onClick={::this.openAndScroll}>
          <div className={this.state.scrollPos > 80 ? 'indicatorIcon floating' : 'indicatorIcon'}>
            <img src='https://ddw2.diamondsdirect.com/img/gallery/search4.svg' />
          </div>
        </div>
        <div className={this.state.filtersOpen ? 'filterWrapper filtersOpen' : 'filterWrapper'}>
          <div className='closeFilters' onClick={::this.closeFilters}>
            <div>&times;</div>
          </div>
          {this.renderFilters()}
        </div>
      </div>
      <div className={this.state.filtersOpen ? 'rbResultsWrapper filtersOpen' : 'rbResultsWrapper'}>
        <div className='rbResultsLoaded'>
          {this.state.displaySplash === true ?
            <div>{this.renderSplashPage()}</div> :
            <div className='rbProductResults'>
              {this.renderResultsSection()}
            </div>
          }
        </div>
      </div>
      {this.state.filtersOpen ?
        <div className={'mobileFooterButton mobileSearchBar'} onClick={() => this.closeFilters(true)}><div>Search</div></div> :
        null
      }
		</div>;
	}
}
export default Gallery;

function mapStateToProps(state) {
  return {
    product: state.product,
  };
}

export const GalleryContainer = connect(
  mapStateToProps,
  allActionCreators
)(Gallery);


// WEBPACK FOOTER //
// ./src/components/views/gallery/Gallery.jsx